// src/pages/Politics.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useData } from "../context/DataProvider";

const Politics = () => {
   const { articles, loading } = useData();

   if (loading) {
      return <div className="p-8">Жүктелуде...</div>;
   }

   // Фильтруем статьи, где CategoryID = "15" (Саясат)
   const politicsArticles = articles.filter((article) => article.CategoryID === "15");

   return (
      <div>
         {/* Шапка (Hero) */}
         <header className="relative bg-gray-900 text-white py-12 px-4 sm:px-6 lg:px-8 mb-8">
            <div
               className="absolute inset-0 bg-cover bg-center opacity-60"
               // style={{
               //    backgroundImage:
               //       "url('https://res.cloudinary.com/ddsogzt5j/image/upload/v1742818180/tw0virowcldluvnp6ubm.jpg')",
               // }}
            />
            <div className="relative max-w-5xl mx-auto">
               <h1 className="text-4xl sm:text-5xl font-bold mb-2">Саясат</h1>
               <p className="text-lg text-gray-200 max-w-2xl">
                  Ел өміріндегі саяси оқиғалар мен өзгерістердің мәнін талдап, сараптайтын ақпарат көздеріңізге қош келдіңіздер.
                  Саясаткерлердің бастамалары мен заңнамалық жаңалықтардан бастап халықаралық қатынастарға дейінгі түрлі мәселелер
                  осы жерде қаралады.
               </p>
            </div>
         </header>

         {/* Негізгі контент */}
         <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <section className="mb-8">
               <h2 className="text-2xl font-bold mb-4">Қош келдіңіздер!</h2>
               <p className="mb-4">
                  Бұл бөлімде ел саясатының барлық саласын қамтитын жаңалықтар мен талдауларды таба аласыздар. Саяси партиялардың
                  іс-шаралары, Парламент пен Үкіметтің шешімдері, сондай-ақ халықаралық ынтымақтастық жөніндегі ақпараттар да
                  назардан тыс қалмайды.
               </p>
               <p>
                  Саяси тұрақтылық пен қоғамның дамуында атқарылып жатқан істерді бақылау, түсіну үшін біз сарапшылардың
                  көзқарастарын ұсынамыз. Халықаралық аренада болып жатқан геосаяси өзгерістер, дипломатиялық қатынастар және
                  басқа да қызықты тақырыптарды бірге талқылаймыз.
               </p>
            </section>

            {/* Сетка новостей (ID=15) */}
            <section>
               <h2 className="text-xl font-bold mb-4">Саяси жаңалықтар</h2>

               {politicsArticles.length === 0 ? (
                  <p>Саясат санатында жаңалықтар жоқ</p>
               ) : (
                  <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                     {politicsArticles.map((article) => (
                        <PoliticsCard key={article.ID} article={article} />
                     ))}
                  </div>
               )}
            </section>
         </main>
      </div>
   );
};

/* Карточка одной новости */
function PoliticsCard({ article }) {
   const { ID, Title, Category, Date, ImageUrl } = article;

   return (
      <article className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
         <img
            src={ImageUrl || "https://via.placeholder.com/400x300"}
            alt={Title}
            className="w-full h-48 object-cover rounded-t-lg"
         />
         <div className="p-4">
            <p className="text-xs text-gray-500 mb-1">
               {Category} &mdash; {Date}
            </p>
            <h3 className="text-base font-semibold text-gray-800 mb-2 line-clamp-2">{Title}</h3>
            <Link to={`/news/${ID}`} className="text-sm text-blue-600 hover:underline">
               Толықтай оқу
            </Link>
         </div>
      </article>
   );
}

export default Politics;
